import React, { Component } from 'react'
import { Row, Col, Spin, Input, Radio, Select, Button, Upload, Icon } from 'antd'
import { app } from "../app"
import Card from "../components/Card"
import '../css/manual.css'
import Head from "../components/Head"
import Iconz from "../components/Iconz"
import api from "../api"
import FormModal from "../components/FormModal2"
import config from "../config"

const RadioGroup = Radio.Group
const RadioButton = Radio.Button
const Option = Select.Option

function normFile (e) {
    if (Array.isArray(e)) {
        return e
    }
    return e && e.fileList
}

class ManualList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            data_load_id: undefined,
            manualList: [],
            imageUrl: [],
            manualInfo: {},
            search_status: '1',
            search_name: '',
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleDataList()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据
     * @returns {Promise<void>}
     */
    handleDataList = async () => {
        await this.setData({ loading: true })
        let { search_status, search_name } = this.state, params = {
            name: search_name,
            status: search_status,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.HandbookLists, params), manualInfo = {}
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }

        if (data.length > 0) {
            manualInfo.name = data[0].name
            this.handleDataDetail(data[0].id)
        }
        await this.setData({ loading: false, manualList: data, manualInfo })
    }

    /**
     * 详情数据
     * @returns {Promise<void>}
     */
    handleDataDetail = async (id) => {
        await this.setData({ detail_loading: true, data_load_id: id })
        let params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.HandbookDetails, params)
        if (flag !== 1) {
            app.alert(msg, "error")
        }
        if (id === this.state.data_load_id) {
            await this.setData({ detail_loading: false, manualInfo: data || {} })
        }
    }

    /**
     * 状态变更
     * @param search_status
     * @returns {Promise<void>}
     */
    handleStatusChange = async (search_status) => {
        await this.setData({ search_status })
        await this.handleDataList()
    }

    /**
     * 关闭添加对话框
     */
    handleCloseAddModal = () => {
        this.setData({ add_modal_visible: false, add_loading: false })
    }

    /**
     * 打开添加对话框
     */
    handleOpenAddModal = () => {
        this.setData({ add_modal_visible: true, imageUrl: [] })
    }

    /**
     * 关闭编辑对话框
     */
    handleCloseEditModal = () => {
        this.setData({ edit_modal_visible: false, edit_loading: false })
    }

    /**
     * 打开编辑对话框
     */
    handleOpenEditModal = () => {
        let imageUrl = this.state.manualInfo.img
        this.setData({ edit_modal_visible: true, imageUrl })
    }

    /**
     * 上传变更
     * @param file
     */
    handleUploadChange = async ({ file, fileList }) => {
        if (file.status === 'uploading') {
            await this.setData({ up_loading: true })
        } else {
            if (file.status === 'done' && file.response && file.response.flag === 1) {
                this.state.imageUrl.push(file.response.data.url)
            } else if (file.status === 'removed') {
                this.state.imageUrl = fileList.map(f => {
                    if (f.status === 'done' && f.response && f.response.flag === 1) {
                        return f.response.data.url
                    }
                })
            }
            await this.setData({ up_loading: false })
        }
    }

    /**
     * 添加使用手册
     */
    handleAdd = async (values) => {
        await this.setData({ add_loading: true })
        let { up_loading, imageUrl } = this.state
        if (up_loading) {
            app.alert('图片正在上传中', 'warn')
            return
        }
        values.indexno = app.getData('indexno')
        values.account = app.getData('account')
        values.url = imageUrl.join(':::')
        let { flag, msg } = await app.post(api.HandbookAdd, values)
        if (flag === 1) {
            app.alert("添加成功", "success")
            await this.handleCloseAddModal()
            await this.handleDataList()
        } else {
            app.alert(msg, "error")
            await this.setData({ add_loading: false })
        }
    }

    /**
     * 编辑使用手册
     */
    handleEdit = async (values) => {
        await this.setData({ edit_loading: true })
        console.log(values)
        let { up_loading, imageUrl, manualInfo } = this.state
        if (up_loading) {
            app.alert('图片正在上传中', 'warn')
            return
        }
        values.indexno = app.getData('indexno')
        values.account = app.getData('account')
        values.id = manualInfo.id
        values.url = imageUrl.join(':::')
        let delUrl = []
        for (let i = 0; i < manualInfo.img.length; i++) {
            if (imageUrl.indexOf(manualInfo.img[i]) === -1) {
                delUrl.push(manualInfo.img[i])
            }
        }
        values.delUrl = delUrl.join(':::')
        let { flag, msg } = await app.post(api.HandbookEdit, values)
        if (flag === 1) {
            app.alert("修改成功", "success")
            await this.handleCloseEditModal()
            await this.handleDataList()
        } else {
            app.alert(msg, "error")
            await this.setData({ edit_loading: false })
        }
    }

    /**
     * 选择手册
     **/
    handleSelectManual = (e) => {
        this.handleDataDetail(e.target.value)
    }

    /**
     * 手册搜索
     **/
    handleSearch = async (search_name) => {
        await this.setData({search_name})
        await this.handleDataList()
    }


    render () {
        let {
                data_load_id, manualList, loading, search_status, add_modal_visible, manualInfo, edit_modal_visible,
                add_loading, edit_loading, detail_loading, imageUrl
            } = this.state,
            card_style = {
                padding: 25,
                height: 'calc(100vh - 228px)',
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                borderRight: '1px solid #eee',
            },
            formItemLayout = {
                labelCol: { span: 4 },
                wrapperCol: { span: 16, offset: 1 }
            }
        return (
            <div className="manual">
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48}/>
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history}/>
                <div className="manual-content">
                    <div className="mc-title">使用手册管理</div>
                    <Row style={{ height: '100%' }}>
                        <Col span={6} style={{ height: '100%' }}>
                            <Card width="100%" height="100%" title={
                                <Row type="flex" justify="space-between" align="center">
                                    <Col>选择手册</Col>
                                    <Button type="primary" onClick={() => this.handleOpenAddModal()}>添加手册</Button>
                                </Row>
                            } style={card_style}>
                                <div style={{ height: '100%' }}>
                                    <Input.Search
                                        placeholder="输入关键词搜索"
                                        onSearch={this.handleSearch}
                                        className="search"
                                        addonBefore={
                                            <Select defaultValue={search_status} style={{ width: 90 }}
                                                    onChange={(e) => this.handleStatusChange(e)}>
                                                <Option value="1">PC</Option>
                                                <Option value="2">小程序</Option>
                                            </Select>
                                        }
                                    />
                                    {
                                        loading ?
                                            (<Row className="data-loading" type="flex" align="middle"
                                                  justify="center"><Spin/></Row>) :
                                            <RadioGroup onChange={this.handleSelectManual} className="manual-list"
                                                        value={data_load_id}>
                                                {
                                                    manualList.length > 0 ?
                                                        manualList.map((manual, index) => {
                                                            return (
                                                                <RadioButton key={index + 1} className='no-select'
                                                                             value={manual.id}>
                                                                    <div title={manual.name}>{manual.name}</div>
                                                                </RadioButton>
                                                            )
                                                        }) : (
                                                            <p style={{ textAlign: "center", padding: "20px 0" }}>无对应手册</p>)
                                                }
                                            </RadioGroup>
                                    }
                                </div>
                            </Card>
                        </Col>
                        <Col span={17} offset={1}>
                            <Card width="100%" height="100%" title={
                                <Row type="flex" justify="space-between" align="center">
                                    <Col>{manualInfo.name || '手册'}</Col>
                                    <Button type="primary" disabled={detail_loading}
                                            onClick={() => this.handleOpenEditModal()}>编辑手册</Button>
                                </Row>
                            } style={card_style}>
                                {
                                    detail_loading ?
                                        (<Row className="data-loading" type="flex" align="middle"
                                              justify="center"><Spin size="large"/></Row>) :
                                        <div className="mc-imgs">
                                            {
                                                manualInfo.img && manualInfo.img.map((img, index) => {
                                                    return (
                                                        <div className="mci-img" key={index}>
                                                            <img src={config.imgUrl + img} alt=""/>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="mc-remark">{manualInfo.remark}</div>
                                        </div>
                                }
                            </Card>
                        </Col>
                    </Row>
                </div>
                <FormModal modal={{
                    visible: add_modal_visible,
                    okText: "添加",
                    cancelText: "取消",
                    title: "添加手册",
                    width: 800,
                    centered: true,
                    maskClosable: false,
                    onCancel: this.handleCloseAddModal,
                    confirmLoading: add_loading,
                    destroyOnClose: true,
                }} onSubmit={this.handleAdd} children={[
                    {
                        formItemLayout,
                        label: "手册名称",
                        name: "name",
                        options: {
                            rules: [
                                { required: true, message: '请填写手册名称' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "手册类型",
                        name: "status",
                        options: {
                            rules: [
                                { required: true, message: '请选择手册类型' },
                            ]
                        },
                        component: (
                            <RadioGroup>
                                <Radio value="1">PC</Radio>
                                <Radio value="2">小程序</Radio>
                            </RadioGroup>
                        )
                    },
                    {
                        formItemLayout,
                        label: "手册图片",
                        name: "url",
                        options: {
                            rules: [{ required: true, message: "请上传手册图片" }],
                            valuePropName: 'fileList',
                            getValueFromEvent: normFile,
                        },
                        component: (
                            <Upload action={config.serverUrl + api.ImageUpload}
                                    accept='image/jpeg, image/jpg, image/png'
                                    data={{
                                        token: app.getData('token'),
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        upload_type: 'hand_book',
                                    }}
                                    name="image"
                                    listType="picture"
                                    className="upload-list-inline"
                                    onChange={this.handleUploadChange}
                                    showUploadList={true}
                            >
                                <Button>
                                    <Icon type="upload"/> 点击上传
                                </Button>
                            </Upload>
                        )
                    },
                    {
                        formItemLayout,
                        label: "手册备注",
                        name: "remark",
                        options: {
                            rules: [
                                { required: true, message: '请输入手册备注' },
                            ]
                        },
                        component: (
                            <Input.TextArea autosize={{ minRows: 4, maxRows: 8 }}/>
                        ),
                    }
                ]}/>


                <FormModal modal={{
                    visible: edit_modal_visible,
                    okText: "提交",
                    cancelText: "取消",
                    title: "编辑手册",
                    width: 800,
                    centered: true,
                    maskClosable: false,
                    onCancel: this.handleCloseEditModal,
                    confirmLoading: edit_loading,
                    destroyOnClose: true,
                }} onSubmit={this.handleEdit} children={[
                    {
                        formItemLayout,
                        label: "手册名称",
                        name: "name",
                        options: {
                            rules: [
                                { required: true, message: '请填写手册名称' },
                            ], initialValue: manualInfo.name
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "手册图片",
                        name: "url",
                        options: {
                            rules: [{ required: true, message: "请上传手册图片" }],
                            valuePropName: 'fileList',
                            getValueFromEvent: normFile,
                            initialValue: (imageUrl || []).map((img, index) => {
                                return {
                                    uid: 0 - (index + 1),
                                    name: 'xx.png',
                                    status: 'done',
                                    url: config.imgUrl + img,
                                    thumbUrl: config.imgUrl + img,
                                    response: {
                                        flag: 1,
                                        data: { url: img }
                                    }
                                }
                            })
                        },
                        component: (
                            <Upload action={config.serverUrl + api.ImageUpload}
                                    accept='image/jpeg, image/jpg, image/png'
                                    data={{
                                        token: app.getData('token'),
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        upload_type: 'hand_book',
                                    }}
                                    name="image"
                                    listType="picture"
                                    className="upload-list-inline"
                                    onChange={this.handleUploadChange}
                                    showUploadList={true}
                            >
                                <Button>
                                    <Icon type="upload"/> 点击上传
                                </Button>
                            </Upload>
                        )
                    },
                    {
                        formItemLayout,
                        label: "手册备注",
                        name: "remark",
                        options: {
                            rules: [
                                { required: true, message: '请输入手册备注' },
                            ], initialValue: manualInfo.remark
                        },
                        component: (
                            <Input.TextArea autosize={{ minRows: 4, maxRows: 8 }}/>
                        ),
                    }
                ]}/>
            </div>
        )
    }
}

export default ManualList



// WEBPACK FOOTER //
// ./src/routes/ManualList.jsx